import { SPONSORED_TILE_TOP_DESTINATION_IDS } from 'constants/sponsoredSearchTopDestinations'

export const SPONSORED_TILE_POSITION_INDEX_TOP_DESTINATION = 8
export const SPONSORED_TILE_POSITION_INDEX_DEFAULT = 3

function useSponsoredSearchTilePlacement(destinationId: string | undefined): number | undefined {
  if (!destinationId) {
    return undefined
  }

  return SPONSORED_TILE_TOP_DESTINATION_IDS.has(destinationId)
    ? SPONSORED_TILE_POSITION_INDEX_TOP_DESTINATION
    : SPONSORED_TILE_POSITION_INDEX_DEFAULT
}

export default useSponsoredSearchTilePlacement
